module.exports = __webpack_public_path__ + "img/diamonds-2.203f0c5.png";